module.exports = __webpack_public_path__ + "img/basement.5f516e84.jpg";